// extracted by mini-css-extract-plugin
export var active = "_hq-7";
export var blink = "_hq-8";
export var dropDownSelector = "_hq-4";
export var dropDownWrapper = "_hq-3";
export var fakeCursor = "_hq-6";
export var fontSizeButton = "_hq-9";
export var formQuillEditor = "_hq-0";
export var pressed = "_hq-a";
export var qlBlank = "_hq-1";
export var textFormattingToolbar = "_hq-2";
export var textToolbarOption = "_hq-5";